import type { ComponentType } from 'react';
import type { RouteName } from '../app/route';
import { Dashboard } from './Dashboard';
import { Pipeline } from './Pipeline';
import { Record } from './Record';
import { Calendar } from './Calendar';
import { CustomerDetail, Customers } from './Customers';
import { Expenses } from './Expenses';
import { Reports } from './Reports';
import { Stats } from './Stats';
import { About } from './About';
import { Settings } from './Settings';
import { Bill } from './Bill';
import { Account } from './Account';

export const PAGES: Partial<Record<RouteName, ComponentType>> = {
  dashboard: Dashboard, enquiries: Pipeline, bookings: Pipeline, booking: Record, calendar: Calendar, customers: Customers, customer: CustomerDetail,
  expenses: Expenses, expense: Expenses, reports: Reports, stats: Stats, about: About, settings: Settings, bill: Bill, account: Account,
};
